import React from 'react';
import { Drawer } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { useAppContext } from 'hooks/useAppContext';
import clsx from 'clsx';
import Menu from 'components/Menu';

const useStyles = makeStyles(theme => ({
  drawerPaper: {
    width: theme.drawer.width,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3)
  },
  toolbar: theme.mixins.toolbar,
  appBarShift: {
    flexShrink: 0,
    marginLeft: theme.drawer.width,
    width: `calc(100% - ${theme.drawer.width}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
}));


const AppDrawer = ({ children }) => {
  // we use the context hook to see if drawerOpen is set to true or false, and if it's true we render the drawer
  const context = useAppContext();
  const { drawerOpen } = context;
  const classes = useStyles();

  return (
    <div>
      {
        drawerOpen &&
        <Drawer variant="permanent" classes={{ paper: classes.drawerPaper }} className={clsx(classes.appBar, {
          [classes.appBarShift]: drawerOpen,
        })}>
          <div className={classes.toolbar} />
          <Menu></Menu>
          {children}
        </Drawer>
      }
    </div>
  )
};


export default AppDrawer;